<template>
    <table class="vrm-table vrm-table--striped">
        <thead>
            <tr>
                <th>
                    {{
                        $t('dynamicess.report.' + type, {
                            i18nFallback: getFallbackTranslation(type),
                        })
                    }}
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    {{
                        $t('dynamicess.report.highest', {
                            i18nFallback: 'Highest',
                        })
                    }}
                </td>
                <td>
                    {{ highest }}
                    <abbr>{{ currency }}</abbr>
                </td>
            </tr>
            <tr>
                <td>
                    {{
                        $t('dynamicess.report.average', {
                            i18nFallback: 'Average',
                        })
                    }}
                </td>
                <td>
                    {{ average }}
                    <abbr>{{ currency }}</abbr>
                </td>
            </tr>
            <tr>
                <td>
                    {{
                        $t('dynamicess.report.lowest', {
                            i18nFallback: 'Lowest',
                        })
                    }}
                </td>
                <td>
                    {{ lowest }}
                    <abbr>{{ currency }}</abbr>
                </td>
            </tr>
            <tr>
                <td>
                    {{
                        $t('dynamicess.report.number_hours_minus', {
                            i18nFallback: 'Number of hours with negative prices',
                        })
                    }}
                </td>
                <td>
                    {{ countHoursMinus }}
                    <abbr>
                        {{
                            $t('dynamicess.report.hours', {
                                i18nFallback: 'hour(s)',
                            })
                        }}
                    </abbr>
                </td>
            </tr>
            <tr>
                <td data-i18n="dynamicess.report.number_days_minus">
                    {{
                        $t('dynamicess.report.number_days_minus', {
                            i18nFallback: 'Number of days with negative prices',
                        })
                    }}
                </td>
                <td>
                    {{ countDaysMinus }}
                    <abbr>
                        {{
                            $t('dynamicess.report.days', {
                                i18nFallback: 'day(s)',
                            })
                        }}
                    </abbr>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { Prop, Component, Vue } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
@Component({
    components: {},
})
@AngularLocaleBundle('dynamicess')
@AngularDirective('vrm-report-price')
export default class VrmDatePicker extends Vue {
    @Prop({ type: String, default: 'price' })
    type;
    @Prop({ type: Number, default: '-' })
    highest;
    @Prop({ type: Number, default: '-' })
    average;
    @Prop({ type: Number, default: '-' })
    lowest;
    @Prop({ type: String, default: '' })
    currency;
    @Prop({ type: Number, default: '-' })
    countHoursMinus;
    @Prop({ type: Number, default: '-' })
    countDaysMinus;

    getFallbackTranslation(name) {
        let fallback = name.replaceAll('_', ' ');
        fallback = fallback.charAt(0).toUpperCase() + fallback.slice(1);
        return fallback;
    }
}
</script>
